import { useState } from "react";
import { faqs } from "@/mocks/articles";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section className="py-12 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
            <p className="text-sm text-foreground-600">关于惩罚作文写作的常见疑问解答</p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border border-background-200/70 rounded-xl overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-50 transition-colors"
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4 flex items-start gap-3">
                    <span className="text-primary-500 font-bold mt-0.5 whitespace-nowrap">Q{index + 1}.</span>
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 text-lg transition-transform duration-300 flex-shrink-0 ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? "max-h-96 pb-4 md:pb-5 px-4 md:px-5" : "max-h-0"
                  }`}
                >
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-8">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}